<template>
  <Teleport to="body">
    <UIBaseTransition
      name="fade"
      mode="out-in"
    >
      <div
        v-if="UIStore.getDynamicPopup.component"
        key="dynamic-popup"
        class="dynamic-popup-anchor"
      >
        <Component
          :is="UIStore.getDynamicPopup.component"
          v-bind="UIStore.getDynamicPopup.data || {}"
          :model-value="UIStore.getDynamicPopup.value"
          v-on="popupListeners"
        />
      </div>
    </UIBaseTransition>
  </Teleport>
</template>

<script setup lang="ts">
const UIStore = useUIStore();

function onClose() {
  UIStore.cleanPopup();
}

const popupListeners = computed(() => ({
  ...(UIStore.getDynamicPopup.events || {}),
  'update:modelValue': onClose,
}));
</script>

<style scoped></style>
